import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Typography, Box } from '@mui/material';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import { LabelledList } from '../../../../components/Onboarding/LabelledList';
import Header from '../../../../components/Page/Header';
import { useGlobalStateContext } from '../../../../context/GlobalStateContext/GlobalStateContext';
import { getOrderDetailsList, getMerchantDetailsList, getPricingDetailsList } from '../../helpers';
import { pageStyles } from './styles';
export const OrderReview = () => {
    const { globalState } = useGlobalStateContext();
    const { t: translate } = useTranslation('translation', { keyPrefix: 'ORDER' });
    const navigate = useNavigate();
    const handleBack = () => {
        navigate(-1);
    };
    const { orderDetailsList, merchantDetailsList, pricingDetailsList } = useMemo(() => {
        const { merchant } = globalState;
        return {
            orderDetailsList: getOrderDetailsList(merchant, translate),
            merchantDetailsList: getMerchantDetailsList(merchant, translate),
            pricingDetailsList: getPricingDetailsList(translate),
        };
    }, [globalState.merchant]);
    return (_jsxs(Box, { sx: pageStyles, children: [_jsx(Header, { title: translate('CONFIRM.TITLE'), subtitle: translate('CONFIRM.SUBTITLE'), goBackButton: true, goBackHandler: handleBack }), _jsxs(Box, { className: 'content', children: [_jsxs(Box, { className: 'top', children: [_jsxs(Box, { children: [_jsx(Typography, { variant: 'h2', children: translate('CONFIRM.ORDER_TITLE') }), _jsx(LabelledList, { list: orderDetailsList })] }), _jsx("hr", { "aria-hidden": true }), _jsxs(Box, { children: [_jsx(Typography, { variant: 'h2', children: translate('CONFIRM.BUSINESS_TITLE') }), _jsx(LabelledList, { list: merchantDetailsList })] })] }), _jsxs(Box, { className: 'list-grid-container', children: [_jsx(Typography, { variant: 'h2', children: translate('CONFIRM.PRICING_TITLE') }), _jsx(LabelledList, { list: pricingDetailsList })] })] })] }));
};
